// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"styles_arrowIcon__1lSW5","tableTitleWrapper":"styles_tableTitleWrapper__1G5zy","sortingIconsWrapper":"styles_sortingIconsWrapper__1KMz4"};